import { Permission } from "../constants/permission";

export const hasPermission = (permission: Permission, user: User | UserWithColor): boolean => {
  return /*user.role == "ADMIN" || */ (permission & user.featurePermissions) > 0;
};
